import { createClient, type SupabaseClient } from '@supabase/supabase-js';

// The account system is OPTIONAL: with no Supabase env baked into the build
// the factory returns null and the whole account UI stays hidden.
export function clientFromEnv(url?: string, anonKey?: string): SupabaseClient | null {
  if (!url || !anonKey) return null;
  return createClient(url, anonKey);
}

export function createAccountClient(): SupabaseClient | null {
  return clientFromEnv(import.meta.env.VITE_SUPABASE_URL, import.meta.env.VITE_SUPABASE_ANON_KEY);
}
